var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['hero', _vm.isLogged],style:(_vm.cssVars)},[_c(_vm.getHeroComponent,{key:_vm.currentLanguage,tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }